export default __webpack_public_path__ + "static/media/Screenshot (1133).3f6a8e69.png";